import { useEffect, useState } from "react";
import { CheckTest, PopupResult, QuestionCard } from "../styles/TestCard.Main";
import { MTButton } from "../../../components/button/MTButton";
import RiskPlanList from "./Risk_Plan_List";
import { ICON_INFO } from "../../../utils/useIcons";

const ViewCarAccidentCase = ({
  formRisk,
  setFormRisk,
  setMenu,
  setRiskData,
}) => {
  const [openResult, setOpenResult] = useState(false);

  //---------- ข้อหนึ่ง ----------//
  const onChangeCarAccidentLevelPassAway = (e) => {
    let value = e.target.value;
    if (value === "high") {
      setFormRisk({
        ...formRisk,
        car_accident_level_pass_away_high: true,
        car_accident_level_pass_away_medium: false,
        car_accident_level_pass_away_low: false,
      });
    } else if (value === "medium") {
      setFormRisk({
        ...formRisk,
        car_accident_level_pass_away_high: false,
        car_accident_level_pass_away_medium: true,
        car_accident_level_pass_away_low: false,
      });
    } else {
      setFormRisk({
        ...formRisk,
        car_accident_level_pass_away_high: false,
        car_accident_level_pass_away_medium: false,
        car_accident_level_pass_away_low: true,
      });
    }
  };

  //---------- ข้อสอง ----------//
  const onChangeCarAccidentPassAwayYesterday = (e) => {
    let value = e.target.value;
    if (value === "high") {
      setFormRisk({
        ...formRisk,
        car_accident_pass_away_yesterday_high: true,
        car_accident_pass_away_yesterday_medium: false,
        car_accident_pass_away_yesterday_low: false,
      });
    } else if (value === "medium") {
      setFormRisk({
        ...formRisk,
        car_accident_pass_away_yesterday_high: false,
        car_accident_pass_away_yesterday_medium: true,
        car_accident_pass_away_yesterday_low: false,
      });
    } else {
      setFormRisk({
        ...formRisk,
        car_accident_pass_away_yesterday_high: false,
        car_accident_pass_away_yesterday_medium: false,
        car_accident_pass_away_yesterday_low: true,
      });
    }
  };

  //---------- ข้อสาม ----------//
  const onChangeCarAccidentManageRisk = (e) => {
    let value = e.target.value;
    if (value === "avoid") {
      setFormRisk({
        ...formRisk,
        car_accident_manage_risk_avoidance: true,
        car_accident_manage_risk_control: false,
        car_accident_manage_risk_accept: false,
        car_accident_manage_risk_transfer: false,
      });
    } else if (value === "control") {
      setFormRisk({
        ...formRisk,
        car_accident_manage_risk_avoidance: false,
        car_accident_manage_risk_control: true,
        car_accident_manage_risk_accept: false,
        car_accident_manage_risk_transfer: false,
      });
    } else if (value === "accept") {
      setFormRisk({
        ...formRisk,
        car_accident_manage_risk_avoidance: false,
        car_accident_manage_risk_control: false,
        car_accident_manage_risk_accept: true,
        car_accident_manage_risk_transfer: false,
      });
    } else {
      setFormRisk({
        ...formRisk,
        car_accident_manage_risk_avoidance: false,
        car_accident_manage_risk_control: false,
        car_accident_manage_risk_accept: false,
        car_accident_manage_risk_transfer: true,
      });
    }
  };

  //---------------------------//

  const getSum = () => {
    let sumScore = 0;
    if (formRisk?.car_accident_pass_away_yesterday_high) {
      sumScore += 2;
    }
    if (formRisk?.car_accident_pass_away_yesterday_medium) {
      sumScore += 1;
    }
    if (formRisk?.car_accident_manage_risk_avoidance) {
      sumScore += 1;
    }
    if (formRisk?.car_accident_manage_risk_control) {
      sumScore += 1;
    }
    if (formRisk?.car_accident_manage_risk_accept) {
      sumScore += 1;
    }
    if (formRisk?.car_accident_manage_risk_transfer) {
      sumScore += 1.5;
    }

    return sumScore;
  };

  useEffect(() => {
    setFormRisk({
      ...formRisk,
      car_accident_sum_score: getSum(),
    });
    setRiskData({
      ...formRisk,
      car_accident_sum_score: getSum(),
    });
  }, [getSum()]);

  useEffect(() => {
    if (openResult) {
      document?.getElementById("result_car_accident")?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [openResult]);

  const onClickSubmit = () => {
    setOpenResult(!openResult);
  };

  // console.log("formRisk : ", formRisk);
  // console.log("sum : ", getSum());

  return (
    <div className="mt-[14px] px-[25px]">
      <div className=" flex flex-col justify-center items-center gap-1">
        <img src="/images/risk_car_accident.svg" className=" h-[50px]" />
        <div className=" text-center text-black font-semibold ">
          กรณีอุบัติเหตุทางรถยนต์
        </div>
      </div>
      <div className=" flex flex-col gap-4 mt-[14px]">
        <QuestionCard
          name="one"
          checkedHigh={formRisk?.car_accident_level_pass_away_high}
          checkedMedium={formRisk?.car_accident_level_pass_away_medium}
          checkedLow={formRisk?.car_accident_level_pass_away_low}
          formRisk={formRisk}
          onChange={onChangeCarAccidentLevelPassAway}
          question="1. ท่านคิดว่าโอกาสการเกิดอุบัติเหตุทางรถยนต์ของท่านอยู่ในระดับใด"
          choice1={`สูง`}
          choice2={`กลาง`}
          choice3={`ต่ำ`}
        />
        <QuestionCard
          name="two"
          checkedHigh={formRisk?.car_accident_pass_away_yesterday_high}
          checkedMedium={formRisk?.car_accident_pass_away_yesterday_medium}
          checkedLow={formRisk?.car_accident_pass_away_yesterday_low}
          formRisk={formRisk}
          onChange={onChangeCarAccidentPassAwayYesterday}
          question="2. ถ้าเมื่อวานมีอุบัติเหตุทางรถยนต์ซึ่งมีความเสียหายสูง จะมีผลกระทบทางการเงินกับท่านระดับใด"
          choice1={`สูง`}
          choice2={`กลาง`}
          choice3={`ต่ำ`}
        />
        <QuestionCard
          name="three"
          checkedAvoidance={formRisk?.car_accident_manage_risk_avoidance}
          checkedControl={formRisk?.car_accident_manage_risk_control}
          checkedAccept={formRisk?.car_accident_manage_risk_accept}
          checkedTransfer={formRisk?.car_accident_manage_risk_transfer}
          formRisk={formRisk}
          onChange={onChangeCarAccidentManageRisk}
          position={"verticle"}
          question={
            <div className="flex gap-1.5">
              3.
              ท่านมีวิธีการจัดการความเสี่ยงกรณีอุบัติเหตุทางรถยนต์ในปัจจุบันอย่างไร
              <a href="https://www.youtube.com/watch?v=PlqpT01BoIk">
                <ICON_INFO className={`flex-none text-gray90 w-6 h-6`} />
              </a>
            </div>
          }
          choice1={`หลีกเลี่ยงความเสี่ยง`}
          choice2={`ควบคุมความเสี่ยง`}
          choice3={`รับความเสี่ยง`}
          choice4={`โอนความเสี่ยง`}
        />
      </div>

      <div className="flex justify-center my-6">
        <MTButton
          text="แสดงผลลัพธ์"
          // loading={loading}
          onClick={onClickSubmit}
        />
      </div>

      {openResult && (
        <div className="flex flex-col">
          <div className=" text-mainblue font-semibold text-center mt-6 mb-4 ">
            ผลลัพธ์วางแผนกรณีอุบัติเหตุทางรถยนต์
          </div>

          {formRisk?.car_accident_sum_score === 1 && (
            <PopupResult
              img="/images/caraccidentshield.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`แนะนำให้ท่านโอนความเสี่ยง`}
              text2={`ด้วยการทำประกันภัยภาคบังคับ พ.ร.บ.`}
            />
          )}

          {formRisk?.car_accident_sum_score === 1.5 && (
            <PopupResult
              img="/images/caraccidentshield_good.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้ `}
              text2={`เหมาะสมแนะนำให้ท่านโอนความเสี่ยงด้วย`}
              text3={`การทำประกันภัยภาคบังคับ พ.ร.บ.`}
            />
          )}

          {formRisk?.car_accident_sum_score === 2 && (
            <PopupResult
              img="/images/caraccidentshield_one_two.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`แนะนำให้ท่านโอนความเสี่ยงด้วยการทำ`}
              text2={`ประกันภัยรถยนต์ภาคสมัครใจ ชั้น1, ชั้น2, ชั้น3`}
              text3={`และ ภาคบังคับ พ.ร.บ.`}
            />
          )}

          {formRisk?.car_accident_sum_score === 2.5 && (
            <PopupResult
              img="/images/caraccidentshield_three_four.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยง`}
              text2={`ได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยง`}
              text3={`ด้วยการทำประกันภัยรถยนต์ภาคสมัครใจ ชั้น2,`}
              text4={`ชั้น3 และ ภาคบังคับ พ.ร.บ.`}
            />
          )}

          {formRisk?.car_accident_sum_score >= 3 && (
            <PopupResult
              img="/images/good_caraccidentshield_one_two.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้`}
              text2={`เหมาะสมแนะนำให้ท่านโอนความเสี่ยงด้วยการทำ`}
              text3={`ประกันภัยรถยนต์ภาคสมัครใจ ชั้น1, ชั้น2, ชั้น3 `}
              text4={`และ ภาคบังคับ พ.ร.บ.`}
            />
          )}

          <div className=" mt-6">
            <div className=" text-black text-center font-medium">
              แบบทดสอบวิธีจัดการความเสี่ยงของท่าน
            </div>
            <RiskPlanList formRisk={formRisk} setMenu={setMenu} />
          </div>
        </div>
      )}
      <div className="mt-6" id="result_car_accident"></div>
    </div>
  );
};
export default ViewCarAccidentCase;
